<template>
  <div>
    <div class="workOrder_info">
      <div class="left">
        <p>领用科室: {{ this.info.desk }}-{{ this.info.address }}</p>
        <p>
          设备信息:
          {{ this.info.facilityName == null ? "无" : this.info.facilityName }}
        </p>
        <p v-if="this.info.sysConsumableReceiveDetails[0]">
          耗材信息:{{ this.info.sysConsumableReceiveDetails[0].inventoryName }}/{{this.info.sysConsumableReceiveDetails[0].model}}*{{this.info.sysConsumableReceiveDetails[0].alterNum}}{{this.info.sysConsumableReceiveDetails[0].unit}}
        </p>
        <div v-for="item in this.sysConsumableReceiveDetailsT" :key="item">
          <p class="consumableClass">
            {{ item.inventoryName }}/{{item.model}}*{{item.alterNum}}{{item.unit}}
          </p>
        </div>
      </div>

      <div class="center" v-show="this.info.state == 3 ? true : false">
        <el-steps :active="5" align-center>
          <el-step title="建单"
                   :description="this.info.createTime"
                   icon="el-icon-add-location"
          ></el-step>
          <el-step
              title="响应时间"
              :description="responseTime"
              icon="el-icon-time"
              style="color: red"
          ></el-step>
          <el-step
              title="处理"
              :description="this.info.receiveTime"
              icon="el-icon-refresh-right"
          ></el-step>
          <el-step
              title="处理时间"
              :description="handlingTime"
              icon="el-icon-time"
          ></el-step>
          <el-step title="完成"
                   :description="this.info.finishTime"
                   icon="el-icon-circle-check"
          ></el-step>
        </el-steps>
        <!--  <p class="elp elp1">{{ responseTime }}</p>
        <p class="elp elp2">{{ handlingTime }}</p> -->
      </div>
      <div class="right" style="margin-right: 10px">
        <h1 class="common_color1" v-if="this.info.state === 1 ">已申请</h1>
        <h1 class="common_color2" v-if="this.info.state === 2">派送中</h1>
        <h1 class="common_color3" v-if="this.info.state === 3">
          {{ handlingTime2 }}
        </h1>
      </div>
    </div>
    <el-divider class="divider"></el-divider>
    <div class="block">
      <el-timeline>
        <!-- 待处理 -->
        <div v-if="this.info.state === 1">
          <el-timeline-item
              :timestamp="this.info.createTime"
              placement="top"
              size="large"
              color="#409eff"
          >
            <el-card>
              <h3>提交申请</h3>
              <span>申请时间: {{ this.info.createTime }}</span>
              <p style="height: 10px"></p>
              <p v-show="this.info.maintainerName == null ? false : true">
                指派接单: {{ this.info.maintainerName }}
              </p>
            </el-card>
          </el-timeline-item>
        </div>

        <!-- 处理中 -->
        <div v-if="this.info.state === 2">
          <el-timeline-item
              :timestamp="this.info.deliveryTime"
              placement="top"
              color="#409eff"
          >
            <el-card>
              <h3>货物派送中</h3>
              <span>接单时间: {{ this.info.deliveryTime }}</span>
              <p style="height: 10px"></p>
              <p>{{ maintainerName }}开始派送</p>
            </el-card>
          </el-timeline-item>
          <el-timeline-item
              :timestamp="this.info.createTime"
              placement="top"
              size="large"
          >
            <el-card>
              <h3>提交申请</h3>
              <span>申请时间: {{ this.info.createTime }}</span>
              <p style="height: 10px"></p>
              <p v-show="this.info.maintainerName == null ? false : true">
                指派接单: {{ this.info.maintainerName }}
              </p>
            </el-card>
          </el-timeline-item>
        </div>

        <!-- 已完成 -->
        <div v-if="this.info.state === 3">
          <el-timeline-item
              :timestamp="this.info.finishTime"
              placement="top"
              color="#409eff"
          >
            <el-card>
              <h3>货物派送完成</h3>
              <span>完成时间: {{ this.info.finishTime }}</span>
              <p style="height: 10px"></p>
              <p style="fontsize: 20px">
                {{ this.info.maintainerName }}已派送完成
              </p>
            </el-card>
          </el-timeline-item>
          <el-timeline-item :timestamp="this.info.deliveryTime" placement="top">
            <el-card>
              <h3>货物派送中</h3>
              <span>接单时间: {{ this.info.deliveryTime }}</span>
              <p style="height: 10px"></p>
              <p>{{ maintainerName }}开始派送</p>
            </el-card>
          </el-timeline-item>
          <el-timeline-item
              :timestamp="this.info.createTime"
              placement="top"
              size="large"
          >
            <el-card>
              <h3>提交申请</h3>
              <span>申请时间: {{ this.info.createTime }}</span>
              <p style="height: 10px"></p>

              <p v-show="this.info.maintainerName == null ? false : true">
                指派接单: {{ this.info.maintainerName }}
              </p>
            </el-card>
          </el-timeline-item>
        </div>
      </el-timeline>
    </div>
  </div>
</template>
<script>
import Clipboard from "clipboard";

export default {
  name: "orderInfo",
  components: {},
  props: {
    kv: null,
    workId: {
      type: String,
      value: "",
    },
    callId: {
      type: String,
      value: "",
    },
  },
  watch: {
    kv(v) {
    },
  },
  data() {
    return {
      text: "",
      mname: "inventory",
      info: {},
      list: [],
      id: "",
      data1: [],
      data2: [],
      total: this.total,

      sysConsumableReceiveDetailsT:[],

      maintainerName: "",

      responseTime: "", //响应时间
      handlingTime: "", //处理时间
      handlingTime2: "", //总处理时间
      assetNum: "", //设备编号
      facilityNo: "", //系统编号
      assetId: "", //设备ID
    };
  },
  created() {
    let route = this.$route;
    this.title = route.title || "";
    let query = this.$route.query;
    if (query.kv) {
      this.kv = query.kv;
    }
    if (this.kv) {
      this.initData(this.kv);
    }
    if (this.workId) {
      this.initData(this.workId);
    }
    if (query.callId) {
      this.callId = query.callId;
    }
    if (this.callId) {
      this.initData(this.callId);
    }
  },
  mounted() {
  },
  methods: {
    initData(workId, page = 1) {
      // 加载详情工单数据
      let id = this.kv;
      let callId = this.callId;
      if (callId == null) {
        $utils.api.load(`/admin/system/inventory/${id}`, {}).then((res) => {
          if (res && res.data) {
            this.info = res.data;
            this.maintainerName = res.data.maintainerName;
            this.sysConsumableReceiveDetails = this.info.sysConsumableReceiveDetails
            if (this.sysConsumableReceiveDetails.length > 1){
              for (let i = 1; i < this.sysConsumableReceiveDetails.length; i++) {
                this.sysConsumableReceiveDetailsT.push(this.sysConsumableReceiveDetails[i])
              }
            }

            console.log(this.sysConsumableReceiveDetailsT)
            this.responseTime = this.computingTime(
                this.info.createTime,
                this.info.deliveryTime
            );
            this.handlingTime = this.computingTime(
                this.info.deliveryTime,
                this.info.finishTime
            );
            this.handlingTime2 = this.computingTime(
                this.info.createTime,
                this.info.finishTime
            );
            this.id = this.info.id;


          }
        });
      }
    },
    //计算相差时间
    computingTime(a, b) {
      //a开始时间//b结束时间
      var date3 = new Date(b).getTime() - new Date(a).getTime(); //时间差的毫秒数
      //------------------------------
      //计算出相差天数
      // var days = Math.floor(date3 / (24 * 3600 * 1000));
      //计算出小时数
      var leave1 = date3 % (24 * 3600 * 1000); //计算天数后剩余的毫秒数
      var hours = Math.floor(leave1 / (3600 * 1000));
      //计算相差分钟数
      var leave2 = leave1 % (3600 * 1000); //计算小时数后剩余的毫秒数
      var minutes = Math.floor(leave2 / (60 * 1000));
      //计算相差秒数
      var leave3 = leave2 % (60 * 1000); //计算分钟数后剩余的毫秒数
      var seconds = Math.round(leave3 / 1000);
      return hours + "时" + minutes + "分" + seconds + "秒";
    },
  },
};
</script>
<style lang="less" scoped>
.consumableClass{
  text-indent: 60px;
}
.workOrder_info {
  width: 100%;
  background: #fff;
  border-radius: 5px;
  display: flex;
  justify-content: space-between;

  .left {
    width: 30%;
  }

  .center {
    width: 50%;

    .elp {
      padding-top: 10px;
      position: fixed;
      top: 110px;
      color: #409eff;
    }

    .elp1 {
      left: 44.875rem;
    }

    .elp2 {
      left: 30.375rem;
    }
  }

  .right {
    color: #000;
    font-size: 13px;
    font-weight: 500;
  }
}

.workOrder_info2 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  background: #fff;
  border-radius: 5px;
  position: relative;
  margin-bottom: 10px;
  padding-left: 18px;
  padding-right: 140px;
  /* .left {
    margin-left: 18px;
  }
  .right {
    position: absolute;
    right: 138px;
  } */
}

.workOrder_content {
  padding-top: 20px;
  padding-bottom: 20px;
  padding-left: 20px;
  background: #fff;
  width: 100%;
  border-radius: 5px;

  .title {
    color: #000;
    font-size: 13px;
    font-weight: 600;
  }

  .item_box {
    display: flex;
  }
}

.workOrder_br {
  height: 1px;
  width: 100%;
  background: #f7f7f7;
}

.common_title {
  color: #000;
  font-size: 13px;
  font-weight: 500;
}

.common_image {
  width: 60px;
  height: 60px;
  border-radius: 2px;
  background: #f7f7f7;
}

.common_image_weixiu {
  width: 60px;
  height: 160px;
  border-radius: 2px;
  background: #fff;
  display: flex;
}

.common_color {
  color: #666;
}

.common_color1 {
  color: orange;
  padding-top: 10px;
}

.common_color2 {
  color: blue;
  padding-top: 10px;
}

.common_color3 {
  color: green;
  padding-top: 10px;
}

.block {
  margin-top: 30px;

  p,
  span {
    font-size: 16px;
  }
}

.divider {
  margin: 0;
}
</style>
